import { EMPLOYMENT_TYPES } from 'cpool-constants';
import type { Schema_Beschaeftigung } from 'cpool-schemas';

const getDefaultAzubi = (): {
    beschaeftigung: Extract<Schema_Beschaeftigung, { beschaeftigungsart: typeof EMPLOYMENT_TYPES.AZUBI }>;
} => ({
    beschaeftigung: {
        azubi: {
            ausbildungsVerguetungMonatlich: null,
            endeDerAusbildung: null,
            schulName: null,
            schulStandort: null,
        },
        beschaeftigungsart: EMPLOYMENT_TYPES.AZUBI,
        steuerklasse: null,
    },
});
export default getDefaultAzubi;
